module.exports = __webpack_public_path__ + "static/media/main idea.f61132b9.mp3";